import { render, staticRenderFns } from "./admin-otp.vue?vue&type=template&id=235921dd&scoped=true"
import script from "./admin-otp.vue?vue&type=script&lang=ts"
export * from "./admin-otp.vue?vue&type=script&lang=ts"
import style0 from "./admin-otp.vue?vue&type=style&index=0&id=235921dd&lang=scss"
import style1 from "./admin-otp.vue?vue&type=style&index=1&id=235921dd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235921dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235921dd')) {
      api.createRecord('235921dd', component.options)
    } else {
      api.reload('235921dd', component.options)
    }
    module.hot.accept("./admin-otp.vue?vue&type=template&id=235921dd&scoped=true", function () {
      api.rerender('235921dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/admin-otp.vue"
export default component.exports